import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import MetaFlexivel from '../../components/MetaFlexivel/MetaFlexivel';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function AnimaisMetaFlexivelAdm() {

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });


    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <MetaFlexivel  setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} />
    </>
}